import { makeStyles } from "@material-ui/core";

export const useNttxFooterStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "#DDE6ED",
    textAlign: "center",
    verticalAlign: "middle",
    boxShadow: "0px -4px 8px rgba(0, 0, 0, .15)",
    fontColor: "#354052",
    fontSize: "11px",
    padding: theme.spacing(1),
    position: "fixed",
    bottom: 0,
    width: "100%",
    // height: theme.espn.default.sizes.footerHeight,
  },
}));
